import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { CheckBoxField, CheckBoxWrapper, RightTextLabel } from './styles';
import { ErrorMessage } from '../InputFields/styles';

class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    const {
      input: { value }
    } = props;
    this.state = {
      isChecked: value
    };
    this.onChangeState = this.onChangeState.bind(this);
  }

  componentDidMount() {
    if (this.props.input && this.props.input.value !== 'undefined') {
      this.setState({ isChecked: !!this.props.input.value });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.input &&
      this.props.input.value !== prevProps.input.value &&
      this.props.input.value !== 'undefined'
    ) {
      this.setState({ isChecked: !!this.props.input.value });
    }
  }

  onChangeState() {
    const {
      input: { onChange, readOnly }
    } = this.props;
    const { isChecked } = this.props;
    if (!readOnly) {
      this.setState({ isChecked: !isChecked }, () => {
        if (onChange) {
          onChange(this.state.isChecked);
        }
      });
    }
  }

  render() {
    const { isChecked } = this.state;
    const { input, meta, style, rightLabel, textStyle, touched, error, i18n } = this.props;
    const metaError = meta && meta.touched && meta.error;

    return (
      <CheckBoxField style={style} disabled={input.disabled}>
        <CheckBoxWrapper
          checked={isChecked}
          disabled={input.disabled}
          error={(touched && error) || metaError}
        >
          <input onChange={this.onChangeState} type="checkbox" {...input} />
        </CheckBoxWrapper>

        {rightLabel ?
          <RightTextLabel disabled={input.disabled} style={textStyle}>
            {rightLabel}
          </RightTextLabel>
          :
          null}
        {touched &&
          error && <ErrorMessage>{typeof error === 'string' && i18n.t(error)}</ErrorMessage>}
      </CheckBoxField>
    );
  }
}

CheckBox.propTypes = {
  onChange: PropTypes.func,
  rightLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  textStyle: PropTypes.shape()
};

CheckBox.defaultProps = {
  onChange: null,
  rightLabel: null,
  textStyle: {}
};

export default translate()(CheckBox);
